
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/bookmarked",
      function () {
        return require("private-next-pages/apps/bookmarked.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/bookmarked"])
      });
    }
  